// RoomImagesPage: not built yet, so it says so instead of showing sample content.
import React from "react";
import { ComingSoon } from "../components/ui";

const RoomImagesPage = () => <ComingSoon title="Room images" description="Upload and manage photos of your rooms." />;

export default RoomImagesPage;
